// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"qia-z","subtitle":"ria-z","wrapper":"sia-z","leftArrow":"tia-z","rightArrow":"uia-z"};